module.exports = {"610430001":"城关街道","610430101":"官庄镇","610430103":"方里镇","610430104":"润镇","610430105":"车坞镇","610430106":"铁王镇","610430107":"石桥镇","610430109":"十里塬镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/610430.json
// module id = 2954
// module chunks = 0